module.exports = __webpack_public_path__ + "static/media/img17.be36a44a.JPG";